"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClerkApp = void 0;
const tslib_1 = require("tslib");
const react_1 = require("@remix-run/react");
const react_2 = tslib_1.__importDefault(require("react"));
const RemixClerkProvider_1 = require("./RemixClerkProvider");
function ClerkApp(App, opts = {}) {
    return () => {
        const { clerkState } = (0, react_1.useLoaderData)();
        return (
        // @ts-expect-error
        react_2.default.createElement(RemixClerkProvider_1.ClerkProvider, { ...opts, clerkState: clerkState },
            react_2.default.createElement(App, null)));
    };
}
exports.ClerkApp = ClerkApp;
